<template>
  <div class="analysisCard" v-loading="loading" element-loading-text="获取数据中……">
    <div class="ac_top">
      <div class="ac_t_left">
        <div>
          <span>{{ lang.select_a_class }}：</span>
          <el-select
            v-model="selectClass"
            style="width: 120px"
            @change="changeSelect"
          >
            <el-option
              v-for="item in selectClassList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div>
          <span>{{ lang.timePeriod }}：</span>
          <el-date-picker
            v-model="selectTime"
            type="datetimerange"
            range-separator="-"
            style="width: 200px;"
            :start-placeholder="lang.startTime"
            :end-placeholder="lang.endTime"
          >
          </el-date-picker>
        </div>
        <div>
          <span class="ac_t_l_btn" @click="confirmGeneration()">{{
            lang.queding
          }}</span>
        </div>
      </div>
      <div class="ac_t_right" v-if="analysisData.createTime">
        <span>
          <div></div>
          <span>{{ lang.analysisComplete }}</span>
          <span>-</span>
          <span>{{ lang.lastUpdate }}：{{ updateTime }} {{ lang.ago }}</span>
        </span>
        <div>
          <img src="../../../assets/img/re-start.png" />
          <span @click="confirmGeneration()">{{ lang.refresh }}</span>
        </div>

        <div @click="exportAnalysis">
          <img src="../../../assets/img/export.png" />
          <span>{{ lang.export }}</span>
        </div>
      </div>
    </div>
    <div class="ac_main">
      <div class="ac_m_left">
        <overviewOfProgress
          v-show="(showCardIndex === 0 && analysisData.createTime) || showCard1"
          ref="overviewOfProgressRef"
          :analysisData="analysisData.overviewOfProgressData"
          :showCard="showCardIndex"
          :exportBoolean="showCard1"
          @changeShowCard="changeShowCardIndex2"
        />
        <difficultProblems
          v-show="(showCardIndex === 1 && analysisData.createTime) || showCard2"
          ref="difficultProblemsRef"
          :tid="obj.id"
          :analysisData="analysisData.difficultProblemsData"
          :showCard="showCardIndex"
          :exportBoolean="showCard2"
          @changeShowCard="changeShowCardIndex2"
        />
        <abilityStratification
          v-show="(showCardIndex === 2 && analysisData.createTime) || showCard3"
          ref="abilityStratificationRef"
          :analysisData="analysisData.abilityStratificationData"
          :showCard="showCardIndex"
          :exportBoolean="showCard3"
          @changeShowCard="changeShowCardIndex2"
        />
        <teachingSuggestions
          v-show="(showCardIndex === 3 && analysisData.createTime) || showCard4"
          ref="teachingSuggestionsRef"
          :analysisData="analysisData.teachingSuggestionsData"
          :showCard="showCardIndex"
          :exportBoolean="showCard4"
          @changeShowCard="changeShowCardIndex2"
        />

        <template v-if="!analysisData.createTime">
          <span class="ac_m_l_empty">{{ lang.analysisCardEmpty }}</span>
        </template>
      </div>
      <div class="ac_m_right">
        <aiChatArea
          ref="aiChatAreaRef"
          :obj="obj"
          v-show="analysisData.createTime && analysisData.fileUrl"
          :fileUrl="analysisData.fileUrl"
          :studentListId="analysisData.studentList"
        />
      </div>
    </div>
    <exportAnalysisDialog ref="exportAnalysisDialogRef" />
  </div>
</template>

<script>
// import studentsProblems from './studentsProblems.vue';
// import teachingSuggestions from './teachingSuggestions.vue';
import abilityStratification from "./analysisComponemts/abilityStratification.vue";
import difficultProblems from "./analysisComponemts/difficultProblems.vue";
import overviewOfProgress from "./analysisComponemts/overviewOfProgress.vue";
import teachingSuggestions from "./analysisComponemts/teachingSuggestions.vue";
import aiChatArea from "./analysisComponemts/aiChatArea.vue";
import exportAnalysisDialog from "./analysisComponemts/dialog/exportAnalysisDialog.vue";

export default {
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tag:{
      type:Number,
      default:0
    },
  },
  components: {
    abilityStratification,
    difficultProblems,
    overviewOfProgress,
    teachingSuggestions,
    aiChatArea,
    exportAnalysisDialog,
  },
  data() {
    return {
      selectClass: "",
      selectTime: [],
      selectClassList: [{ value: "", label: this.lang.all_classes }],
      showCardIndex: 0,
      loading: false,
      analysisData: {
        overviewOfProgressData: null,
        difficultProblemsData: null,
        abilityStratificationData: null,
        teachingSuggestionsData: null,
      },
      showCard1: false,
      showCard2: false,
      showCard3: false,
      showCard4: false,
    };
  },
  computed: {
    // 计算当前时间与createTime相差多少分钟
    updateTime() {
      if (!this.analysisData.createTime) return "";
      const now = Date.now();
      const create = Number(this.analysisData.createTime);
      const diffMs = now - create;
      const diffMin = Math.floor(diffMs / 1000 / 60);

      if (diffMin < 60) {
        return `${diffMin}${this.lang.minute || "分钟"}`;
      } else if (diffMin < 1440) {
        const hours = Math.floor(diffMin / 60);
        const minutes = diffMin % 60;
        return minutes === 0
          ? `${hours}${this.lang.hour || "小时"}`
          : `${hours}${this.lang.hour || "小时"}${minutes}${
              this.lang.minute || "分钟"
            }`;
      } else {
        const days = Math.floor(diffMin / 1440);
        const hours = Math.floor((diffMin % 1440) / 60);
        if (hours === 0) {
          return `${days}${this.lang.day || "天"}`;
        }
        return `${days}${this.lang.day || "天"}${hours}${
          this.lang.hour || "小时"
        }`;
      }
    },
  },

  watch: {
    obj(newValue) {
      if (newValue.class_id) {
        this.getClassList();
      }
      if (newValue.analysis) {
        this.showCardIndex = 0;
        this.analysisData = JSON.parse(JSON.stringify(newValue.analysis));
    
      }
    },
    // analysisData(newVal){
    //   if(newVal.studentList){
    //     console.log(newVal.studentList)
    //     this.$refs.aiChatAreaRef.setFirstUseSuggested()
    //   }
    // }
    // tag(newValue){
    //   if(newValue==1){
    //     this.showCardIndex = 0;
    //     this.analysisData = JSON.parse(JSON.stringify(newValue.analysis));
    //   }
    // },
  },
  methods: {
    changeSelect() {
      console.log("切换分类");
    },
    // 获取班级
    getClassList() {
      let params = {
        idList: this.obj.class_id,
      };
      this.ajax
        .get(this.$store.state.api + "select_ClassByidList", params)
        .then((res) => {
          let _result = res.data[0];
          if (_result.length > 0) {
            let list = [];
            list.push({ value: "", label: this.lang.all_classes });
            _result.forEach((item) => {
              list.push({ value: item.id, label: item.name });
            });

            this.selectClassList = list;
          }
        })
        .catch((err) => {
          console.log("获取班级失败", err);
        });
    },
    async confirmGeneration() {
      this.loading = true;

      let _studentWork = await this.getStudentWorkData();
      if (_studentWork.length <= 0) {
        this.$message.error(this.lang.noStudentData);
        return (this.loading = false);
      }

      let promise = [];

      promise.push(
        this.$refs.overviewOfProgressRef.generated(_studentWork).then((res) => {
          console.log("overviewOfProgressData", res);
          this.analysisData.overviewOfProgressData = res;
        })
      );
      promise.push(
        this.$refs.difficultProblemsRef.generated(_studentWork).then((res) => {
          console.log("difficultProblemsData", res);
          this.analysisData.difficultProblemsData = res;
        })
      );
      promise.push(
        this.$refs.abilityStratificationRef
          .generated(_studentWork)
          .then((res) => {
            console.log("abilityStratificationData", res);
            this.analysisData.abilityStratificationData = res;
          })
      );
      promise.push(
        this.$refs.teachingSuggestionsRef
          .generated(_studentWork)
          .then((res) => {
            console.log("teachingSuggestionsData", res);
            this.analysisData.teachingSuggestionsData = res;
          })
      );

      promise.push(
        this.getCsvFileUrl(_studentWork).then((res) => {
          console.log("getCsvFileUrl", res);
          this.analysisData.fileUrl = res;
        })
      );

      Promise.all(promise).then(() => {
        this.loading = false;
        this.analysisData.createTime = new Date().getTime();
        this.analysisData.studentList = _studentWork.map((i) => i.id).join(",");
        this.$refs.aiChatAreaRef.changeStudentList(_studentWork);
        this.$emit(
          "changeTeachingModeAnalysis",
          JSON.parse(JSON.stringify(this.analysisData))
        );
        this.$message.success(this.lang.dataUpdateComplete)
      });
    },
    // 获取csv文件
    async getCsvFileUrl(_studentData) {
      return new Promise((resolve) => {
        let statusList = [
          this.lang.unfinished,
          this.lang.completed,
          this.lang.pause,
          this.lang.stop,
        ];
        if (_studentData.length > 0) {
          let _array = [];

          _studentData.forEach((i, index) => {
            let _json = {};
            _json[this.lang.sequenceNumber] = index + 1;
            _json[this.lang.student_name] = i.name;
            _json[this.lang.summary] = i.summary ? i.summary : "-";
            if (i.nodeData.length > 0) {
              let nodeRows = [];
              i.nodeData.forEach((i2, index2) => {
                const nodeLabel = `${this.lang.node}${index2 + 1}`;
                i2.messageList.forEach((i3) => {
                  const userContent = (i3.userContent || "")
                    .toString()
                    .replace(/\r?\n|\r/g, " ");
                  const aiContent = (i3.aiContent || "")
                    .toString()
                    .replace(/\r?\n|\r/g, " ");
                  nodeRows.push(
                    `${nodeLabel} | ${i3.userName}：${userContent} | ${i3.aiName}（ai）：${aiContent}`
                  );
                });
              });
              _json[this.lang.node] = nodeRows.length
                ? nodeRows.join("\n")
                : "-";
            } else {
              _json[this.lang.node] = "-";
            }

            _json[this.lang.last_conversation] = i.lastChat ? i.lastChat : "-";

            _json[this.lang.task_status] = statusList[i.status];

            _array.push(_json);
          });

          // 通过 _array 生成csv文件
          if (_array.length > 0) {
            // 字段顺序
            const headers = [
              this.lang.sequenceNumber,
              this.lang.student_name,
              this.lang.summary,
              this.lang.node,
              this.lang.last_conversation,
              this.lang.task_status,
            ];
            // BOM，防止中文乱码
            let BOM = "\uFEFF";
            // 表头行
            let csvContent = headers.join(",") + "\n";
            // 每行数据
            _array.forEach((row) => {
              const line = headers
                .map((key) => {
                  // csv转义引号、逗号、回车
                  let value = row[key] !== undefined ? row[key] : "";
                  if (typeof value === "string") {
                    value = value.replace(/"/g, '""'); // 双引号转义
                    // 包含逗号或换行需加双引号包裹
                    if (
                      value.indexOf(",") !== -1 ||
                      value.indexOf("\n") !== -1
                    ) {
                      value = `"${value}"`;
                    }
                  }
                  return value;
                })
                .join(",");
              csvContent += line + "\n";
            });

            // 下载csv文件，添加BOM防止中文乱码
            const blob = new Blob([BOM + csvContent], {
              type: "text/csv;charset=utf-8;",
            });
            blob.name = "教学空间.csv";
            this.uploadFileGetUrl(blob).then((res) => {
              resolve(res);
            });
          } else {
            resolve("");
          }
        } else {
          resolve("");
        }
      });
    },
    // 上传文件
    uploadFileGetUrl(file) {
      return new Promise((resolve) => {
        var credentials = {
          accessKeyId: "AKIATLPEDU37QV5CHLMH",
          secretAccessKey: "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",
        }; //秘钥形式的登录上传
        window.AWS.config.update(credentials);
        window.AWS.config.region = "cn-northwest-1"; //设置区域

        var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
        var _this = this;

        _this.$forceUpdate();
        if (file) {
          var params = {
            Key:
              file.name.split(".")[0] +
              new Date().getTime() +
              "." +
              file.name.split(".")[file.name.split(".").length - 1],
            ContentType: file.type,
            Body: file,
            "Access-Control-Allow-Credentials": "*",
            ACL: "public-read",
          }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
          var options = {
            partSize: 2048 * 1024 * 1024,
            queueSize: 2,
            leavePartsOnError: true,
          };
          bucket
            .upload(params, options)
            .on("httpUploadProgress", function (evt) {
              console.log("evt", evt);
            })
            .send(async function (err, data) {
              if (err) {
                resolve("");
              } else {
                resolve(data.Location);
              }
            });
        }
      });
    },
    getStudentWorkData() {
      return new Promise((resolve) => {
        if (!this.obj.id) return resolve([]);
        let params = {
          uid: this.user.userId,
          tid: this.obj.id,
          sid: "",
        };

        this.ajax
          .get(this.$store.state.api + "select_teachingModeWorks", params)
          .then((res) => {
            let _result = res.data[0];
            if (_result.length > 0) {
              // 班级筛选
              if (this.selectClass) {
                _result = _result.filter((item) => {
                  return item.classid == this.selectClass;
                });
              }

              // 时间筛选
              if (this.selectTime.length > 0) {
                _result = _result.filter((item) => {
                  // 时间判断，支持字符串和时间戳类型，确保在区间内
                  const start = new Date(this.selectTime[0]).getTime();
                  const end = new Date(this.selectTime[1]).getTime();
                  const created = new Date(item.create_at).getTime();
                  return created >= start && created <= end;
                });
              }
              _result.forEach((i) => {
                //i.summary = i.summary ? JSON.parse(i.summary) : "";
                i.nodeData = i.nodeData ? JSON.parse(i.nodeData) : [];
              });

              resolve(_result);
            } else {
              resolve([]);
            }
          })
          .catch((err) => {
            console.log(err);
            resolve([]);
          });
      });
    },
    //切换卡片
    changeShowCardIndex(type) {
      if (type === 0) {
        if (this.showCardIndex > 0) {
          this.showCardIndex -= 1;
        }
      } else if (type === 1) {
        if (this.showCardIndex < 3) {
          this.showCardIndex += 1;
        }
      }
    },
    changeShowCardIndex2(index){
      this.showCardIndex = index
    },
    // 导出分析
    exportAnalysis() {
      this.$refs.exportAnalysisDialogRef.open();
    },
    // 进度总览获取图片
    getOverviewOfProgressImg() {
      return new Promise((resolve) => {
        this.showCard1 = true;
        this.$nextTick(() => {
          this.getHtmlImage(this.$refs.overviewOfProgressRef.$el).then(
            (res) => {
              //console.log("getOverviewOfProgressImg", res);
              resolve(res);
              this.showCard1 = false;
            }
          );
        });
      });
    },
    // 疑难问题获取图片
    getDifficultProblemsImg() {
      return new Promise((resolve) => {
        this.showCard2 = true;
        this.$nextTick(() => {
          this.getHtmlImage(this.$refs.difficultProblemsRef.$el).then(
            (res) => {
              //console.log("getDifficultProblemsImg", res);
              resolve(res);
              this.showCard2 = false;
            }
          );
        });
      });
    },
    //能力分层获取图片
    getAbilityStratificationImg() {
      return new Promise((resolve) => {
        this.showCard3 = true;
        this.$nextTick(() => {
          this.getHtmlImage(this.$refs.abilityStratificationRef.$el).then(
            (res) => {
              //console.log("getAbilityStratificationImg", res);
              resolve(res);
              this.showCard3 = false;
            }
          );
        });
      });
    },
    // 教学建议获取图片
    getTeachingSuggestionsImg() {
      return new Promise((resolve) => {
        this.showCard4 = true;
        this.$nextTick(() => {
          this.getHtmlImage(this.$refs.teachingSuggestionsRef.$el).then((res) => {
            //console.log("getTeachingSuggestionsImg", res);
            resolve(res);
            this.showCard4 = false;
          });
        });
      });
    },
    // 通过div获取图片
    getHtmlImage(dom) {
      return new Promise((resolve) => {
        if (!dom) {
          resolve("");
          return;
        }
        // 动态引入html2canvas，避免第一次全量引入
        if (typeof window.html2canvas === "function") {
          window
            .html2canvas(dom, { useCORS: true, backgroundColor: null })
            .then((canvas) => {
              const imgData = canvas.toDataURL("image/png");
              resolve(imgData);
            })
            .catch((err) => {
              console.error("生成图片出错:", err);
              resolve("");
            });
        } else {
          import("html2canvas")
            .then((module) => {
              const html2canvas = module.default || module;
              html2canvas(dom, { useCORS: true, backgroundColor: null })
                .then((canvas) => {
                  const imgData = canvas.toDataURL("image/png");
                  resolve(imgData);
                })
                .catch((err) => {
                  console.error("生成图片出错:", err);
                  resolve("");
                });
            })
            .catch((e) => {
              console.error("加载html2canvas失败:", e);
              resolve("");
            });
        }
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.analysisCard {
  width: 100%;
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  .ac_top {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0;
    .ac_t_left {
      width: 60%;
      height: 100%;
      display: flex;
      align-items: center;
      gap: 20px;
      min-width: 580px;
      & > div {
        display: flex;
        align-items: center;
        gap: 10px;
        & > span {
          color: rgba(150, 155, 163, 1);
          letter-spacing: -0.24px;
          font-weight: 500;
          font-size: 16px;
          white-space: nowrap;
        }
      }
      .ac_t_l_btn {
        padding: 5px 16px;
        color: rgba(150, 155, 163, 1);
        background: rgba(255, 255, 255, 1);
        border-radius: 40px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: 0.3s;
        white-space: nowrap;
        z-index: 2;
        &:hover {
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
        }
      }
    }
    .ac_t_right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 40%;
      height: 100%;
      gap: 20px;
      min-width: 510px;
      & > div {
        padding: 5px 16px;
        color: rgba(150, 155, 163, 1);
        background: rgba(255, 255, 255, 1);
        border-radius: 40px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: 0.3s;
        display: flex;
        align-items: center;
        white-space: nowrap;
        gap: 5px;
        &:hover {
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
        }
      }
      & > span {
        display: flex;
        align-items: center;
        gap: 5px;
        font-weight: 500;
        white-space: nowrap;
        & > div {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(150, 155, 163, 1);
        }
        & > span {
          color: rgba(150, 155, 163, 1);
          font-size: 14px;
          display: block;
        }
      }
    }
  }
  .ac_main {
    width: 100%;
    display: flex;
    flex: 1;
    .ac_m_left {
      width: 60%;
      height: 100%;
      min-height: 600px;
      overflow: auto;
      // min-width: 830px;
      gap: 20px;
      box-sizing: border-box;

      display: flex;
      flex-direction: column;
      // box-sizing: border-box;
      padding: 0px 10px 20px 10px;
      box-sizing: border-box;
      .ac_m_l_empty {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: rgba(150, 155, 163, 1);
      }
    }
    .ac_m_right {
      width: 40%;

      min-height: 600px;
      // min-width: 550px;
      padding: 0px 0px 20px 10px;
      box-sizing: border-box;
    }
  }
}
</style>
